
interface LanguageInterface {
  labelName: string;
  languageCode: string;
}

interface LanguageTranslation {
  LabelId: number;
  labelValue: string;
  languageId: number;
}

interface LabelObject {
  id: number;
  labelName: string;
  LabelTranslations: LanguageTranslation[];
}
export const translations = [
  { id: 1, language: "en"},
  { id: 2, language: "fr"},
  { id: 3, language: "zh"},
  { id: 4, language: "de"},
  { id: 5, language: "it"},
  { id: 6, language: "es"},
  { id: 7, language: "pt"},
  { id: 8, language: "nl"},
  { id: 9, language: "ar"},
  { id: 10, language: "hi"},
  { id: 11, language: "sv"},
  { id: 12, language: "ja"},
];

export function LanguageTranslation({
  labelName,
  languageCode,
}: LanguageInterface) {

  const languageCodeMatch= translations.find((translation) => translation.language === languageCode);

    const languageIdCode = languageCodeMatch?.id;


  const storedDataRaw = localStorage.getItem("labels");
  const storedData: LabelObject[] | null = storedDataRaw
    ? JSON.parse(storedDataRaw)
    : null;

  // Ensure the `item` type matches the shape of your `LabelObject`
  const labelObject = storedData?.find(
    (item: LabelObject) => item?.labelName === labelName
  );

  // Find the specific label value for the given languageCode
  const label = labelObject?.LabelTranslations?.find(
    (label: LanguageTranslation) =>
      label?.languageId === languageIdCode
  );

  return label
    ? label.labelValue
    : labelObject?.LabelTranslations.find(
        (label: LanguageTranslation) => label?.languageId === 2
      )?.labelValue || "";
}
